import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TK_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#TK_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "TK_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#TK_svg__b)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.294 10.063l-.885.548.344-.92L2 8.995h.913L3.294 8l.292.995H4.5l-.659.696.323.92-.87-.548zM7.294 6.063l-.885.548.344-.92L6 4.995h.913L7.294 4l.292.995H8.5l-.659.696.323.92-.87-.548zM11.294 10.063l-.885.548.344-.92L10 8.995h.913L11.294 8l.292.995h.914l-.659.696.323.92-.87-.548zM7.294 14.063l-.885.548.344-.92L6 12.995h.913L7.294 12l.292.995H8.5l-.659.697.323.92-.87-.549z",
      fill: "#F7FCFF"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M24.843 5.463C20.759 7.48 7.341 16.545 7.341 16.545h22.35c-.222-.05-.43-.091-.627-.13-1.64-.327-2.45-.488-4.223-4.018-1.983-3.952 0-6.934 0-6.934zM6.616 17.965l-.305.76.305.835L29.37 20l.63-1.16-.63-.835-22.754-.04z",
      fill: "#FECA00"
    }
  )))
), a = t;
export {
  a as default
};
